import { Pricing } from '@wix/ambassador-partners-profile-v1-partner-profile/types';
import { MAX_PRICE_IN_USD } from '../constants';

export const USD_CURRENCY_CODE = 'USD';

export const convertPricingToUSD = (
  pricing: Pricing,
  currencyConversionRate: number,
): Pricing => {
  return {
    min: convertUserCurrencyToUSD(currencyConversionRate, pricing?.min),
    max: convertUserCurrencyToUSD(currencyConversionRate, pricing?.max),
  };
};

const convertUserCurrencyToUSD = (
  currencyConversionRate: number,
  userCurrencyValue?: number | null,
) =>
  userCurrencyValue
    ? userCurrencyValue / currencyConversionRate
    : userCurrencyValue;

export const getCurrencyConvertedMaxPrice = (
  currencyConversionRate: number,
) => {
  const convertedMaxPrice = currencyConversionRate * MAX_PRICE_IN_USD;
  const scaleExponent = Math.floor(Math.log10(convertedMaxPrice));
  const scale = 10 ** scaleExponent;
  const roundedUnscaledValue = Math.round(convertedMaxPrice / scale);
  const roundedMaxPrice = roundedUnscaledValue * scale;
  return roundedMaxPrice;
};

export const formatCurrency = (
  language: string,
  amount: number = 0,
  minimumFractionDigits = 0,
  maximumFractionDigits = 2,
) =>
  Intl.NumberFormat(language, {
    style: 'currency',
    currency: USD_CURRENCY_CODE,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(amount);
